// extracted by mini-css-extract-plugin
var _1 = "GjMFR";
var _2 = "VvTtY";
var _3 = "wPZZZ";
export { _1 as "column", _2 as "columnValue", _3 as "typeIcon" }
